import { render, staticRenderFns } from "./LocalMission.vue?vue&type=template&id=238c71bd&scoped=true"
import script from "./LocalMission.vue?vue&type=script&lang=js"
export * from "./LocalMission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c71bd",
  null
  
)

export default component.exports